export const environment = {
  production: true,
  clientID: '55ce0900758a49faace8d3334c73a15d',
  clientSecret: '841c3381dd704017ba594a4277f8dcee',
  userAPIBase: 'https://still-ridge-44767.herokuapp.com/api/user',
};
